import Crud from './crud'
import client from '@/services/client'
import Utils from '@/utils'

export default class SiteContractEntryService extends Crud {
  constructor (siteId) {
    super(`/site/${siteId}/contract-entry`)
  }

  filter (query, params) {
    return client.post('/api/site/contract-entry/filter', query, params)
  }

  search (query, params) {
    return client.post('/api/site/contract-entry/search', { search: query }, params)
  }

  filterExportUrl (query) {
    query.export = 1
    return '/api/site/contract-entry/filter?' + Utils.buildQueryString(query)
  }

  searchExportUrl (query) {
    return '/api/site/contract-entry/search?' + Utils.buildQueryString({ search: query, export: 1 })
  }
}
